
import { useEffect } from 'react';
import './App.css';
import AppMainContextProvider from './context/AppMainContext';
import AppRouter from './routes/AppRouter.jsx';

function App() {
  useEffect(() => {
    const setAppHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setAppHeight();
    window.addEventListener("resize", setAppHeight);
    return () => window.removeEventListener("resize", setAppHeight);
  }, []);
  
  return (
    <div className="App" dir='rtl'>
      <AppMainContextProvider>
        <AppRouter/>
      </AppMainContextProvider>
    </div>
  );
}

export default App;
